import { render, staticRenderFns } from "./feeDetail.vue?vue&type=template&id=6817279f&scoped=true&"
import script from "./feeDetail.vue?vue&type=script&lang=js&"
export * from "./feeDetail.vue?vue&type=script&lang=js&"
import style0 from "./feeDetail.vue?vue&type=style&index=0&id=6817279f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6817279f",
  null
  
)

export default component.exports